var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 11 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.665.667H3.443C3.2.667 3 .867 3 1.111v2.222H.776c-.244 0-.444.2-.444.445v7.111c0 .245.2.445.444.445H7c.244 0 .444-.2.444-.445V8.667h2.222c.244 0 .444-.2.444-.444V1.111c0-.244-.2-.444-.444-.444Zm-.444 7.11H7.443V3.779c0-.244-.2-.444-.445-.444h-3.11V1.556H9.22l.001 6.222Z",
  fill: "currentColor"
})));

export default SvgIconCopy;